import { render, staticRenderFns } from "./newsCenter.vue?vue&type=template&id=0e15bb1a&scoped=true&"
import script from "./newsCenter.vue?vue&type=script&lang=js&"
export * from "./newsCenter.vue?vue&type=script&lang=js&"
import style0 from "./newsCenter.vue?vue&type=style&index=0&id=0e15bb1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e15bb1a",
  null
  
)

export default component.exports